const bankAccountTypes = Object.freeze({
    Checking: 0,
    Savings: 1
});

export default bankAccountTypes;
